<template>
  <div class="partner-container">
    <v-toolbar
      flat
      dense
      color="white"
      height="56px"
    >
      <v-btn
        icon
        @click="activePartnerId = null"
      >
        <v-icon color="primary">arrow_forward</v-icon>
      </v-btn>
      <v-toolbar-title>{{ partner.name || 'ללא שם' }}</v-toolbar-title>

      <v-spacer></v-spacer>
      <v-btn
        small
        @click="openPartnerPage"
      >
        דף ספק
      </v-btn>
    </v-toolbar>

    <v-divider />

    <!-- <v-data-table
      :items="partnerData"
      hide-actions
      hide-headers
    >
      <template v-slot:items="props">
        <td class="font-weight-bold text-xs-right">{{ props.item.name }}</td>
        <td class="text-xs-right">
          {{ displayFunction(props.item.key, props.item.value) }}
        </td>
      </template>
    </v-data-table> -->

    <v-sheet
      v-if="partner.description"
      class="pa-4"
    >
      <vue-markdown :source="partner.description || 'אין תיאור'"></vue-markdown>
    </v-sheet>

    <v-divider />

    <v-expansion-panel
      class="elevation-0"
      :value="0"
    >
      <v-expansion-panel-content
        v-for="contact in contacts"
        :key="contact._id"
      >
        <template v-slot:header>
          <span class="title">{{ contact.name }} <v-chip
              v-if="contact.callFirst"
              color="orange"
              small
              disabled
              class="white--text"
            >ליצור קשר ראשון</v-chip></span>
        </template>
        <contact
          :contact="contact"
          :parent-resource="$store.state.resources.partner"
          :roles="[]"
        />
      </v-expansion-panel-content>
    </v-expansion-panel>

  </div>
</template>

<script>
import generateId from "@/idGenerator";
import shouldShow from "@/utils/shouldShow";
import VueMarkdown from "vue-markdown";

import ContactDetailsList from "../../../ContactDetailsList.vue";
import Contact from "../../../Contact.vue";

export default {
  data() {
    return {
      removing: []
    };
  },

  computed: {
    partner() {
      return this.$store.state.entities.partners[this.activePartnerId];
    },
    activePartnerId: {
      get() {
        return this.$store.getters["partners/activePartnersIds"][this.compId];
      },
      set(payload) {
        this.$store.commit("partners/SET_ACTIVE_PARTNER_ID", {
          compId: this.compId,
          payload
        });
      }
    },
    resource() {
      return this.$store.state.resources.partner;
    },
    user() {
      return this.$store.getters["user/user"];
    },
    partnerData() {
      let data = [];
      if (this.resource) {
        let model = this.resource.model;
        for (let key of Object.keys(model)) {
          if (!model[key].hidden && model[key].type !== "TEXTAREA") {
            if (this.partner[key] === false || this.partner[key]) {
              data.push({
                key,
                name: model[key].name,
                value: this.partner[key]
              });
            }
          }
        }
      }
      return data;
    },
    contacts() {
      return this.partner.contacts.map(item => {
        return this.$store.state.entities.contacts[item];
      });
    }
  },
  methods: {
    shouldShow,
    openPartnerPage() {
      this.$router.push('/partners/' + this.activePartnerId);
    },
    displayFunction(key, value) {
      let model = this.resource.model;
      if (model[key].type === "BOOLEAN") {
        return value ? "כן" : "לא";
      } else if (model[key].type === "SELECT") {
        let item = this.$store.state.entities[model[key].items][
          value._id || value
        ];
        if (item) {
          return item[model[key].itemText];
        } else {
          return "לא ידוע";
        }
      } else {
        return value;
      }
    }
  },
  mounted() {},

  props: ["compId"],

  components: {
    VueMarkdown,
    Contact,
    ContactDetailsList
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.partner-container .v-toolbar__content {
  padding: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/events/modules/Partners/Partner.vue